import React from 'react';
import PropTypes from 'prop-types';
import Link from '../../../01_atoms/Link';
import DefaultPicture, { propTypes as picturePropTypes } from '../../../01_atoms/DefaultPicture';
import { propTypes as propTypesLink } from '../../../01_atoms/Link';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const BBHeroRightSideImage = ({
  uuid,
  title,
  description = '',
  type = '',
  image = null,
  showCaption = false,
  imageCaption = '',
  breadcrumbs = [],
  behaviorSettings = null,
}) => {
  // TODO: Make the icon configurable.
  const icon = '/static/icons/landing-page-white.svg';

  const classes = [
    'bb',
    'bb-hero-right-side-image',
    styles['bb-hero-right-side-image'],
    generateClassNameByBehaviorSettings(behaviorSettings),
  ];

  return (
    <div id={uuid} className={classes.join(' ')}>
      <div className={styles['content']}>
        <div className={styles['right']}>
          {!!breadcrumbs.length && (
            <div className={styles['breadcrumbs-mobile']}>
              <Link {...breadcrumbs[0].nextLink}>
                <a
                  title=""
                  href={breadcrumbs[0].nextLink.url}
                  className="analytics-bb-hero-right-side-image-breadcrumbs"
                >
                  {breadcrumbs[0].label}
                </a>
              </Link>
            </div>
          )}
          {image && (
            <div className={styles['image']}>
              <DefaultPicture {...image} />
              {showCaption && <div className={styles['image-capture']}>{imageCaption}</div>}
            </div>
          )}
        </div>

        <div className={styles['left']}>
          {!!breadcrumbs.length && (
            <div className={styles['breadcrumbs']}>
              {breadcrumbs.map((link, i) => {
                if (i + 1 === breadcrumbs.length && !link.nextLink) {
                  return (
                    <div key={`${link.label}-${i}`} className={styles['breadcrumbs-item']}>
                      {link.label}
                    </div>
                  );
                }

                return (
                  <div key={`${link.label}-${i}`} className={styles['breadcrumbs-item']}>
                    <Link {...link.nextLink}>
                      <a
                        title=""
                        href={link.nextLink.url}
                        className="analytics-bb-hero-right-side-image-breadcrumbs"
                      >
                        {link.label}
                      </a>
                    </Link>
                    <span>/</span>
                  </div>
                );
              })}
            </div>
          )}

          <div className={styles['text-info']}>
            <div className="container">
              <div className={styles['text-info-container']}>
                {type && (
                  <div className={styles['type']}>
                    <img src={icon} className={styles['type-icon']} alt="" width={14} height={14} />
                    {type}
                  </div>
                )}

                <h1 className={styles['title']}>{title}</h1>
                <div className={styles['description']}>{description}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

BBHeroRightSideImage.propTypes = {
  uuid: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  type: PropTypes.string,
  image: PropTypes.shape(picturePropTypes),
  imageCaption: PropTypes.string,
  showCaption: PropTypes.bool,
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      nextLink: PropTypes.shape(propTypesLink),
    }),
  ),
  behaviorSettings: behaviorSettingsProps,
};

export default BBHeroRightSideImage;
